import './RewardCard.css';
import { useUI } from '../../hooks/useUI';
import Button from '../Button/Button';
import DropdownButton from '../DropdownButton/DropdownButton';
import { resources } from '../../utils/resources';

const RewardCard = (props) => {
    const { isDropdownOpen, openModal, userData, setRewardValueName, setAssetId } = useUI();
    const isOpen = isDropdownOpen(props.id);

    const toggleMenu = () => {
        console.log('Opening modal for Calculate reward');
        setAssetId(props.assetId);
        setRewardValueName(props.currencyName);
        openModal('modalWindow');
    };

    // Периоды и их длительность в часах
    const periods = [
        { label: '1 Hour', hours: 1 },
        { label: '1 Day', hours: 24 },
        { label: '1 Week', hours: 168 },
        { label: '2 Weeks', hours: 336 },
        { label: '1 Month', hours: 720 },
        { label: '3 Month', hours: 2160 },
        { label: '6 Month', hours: 4320 },
        { label: '1 Year', hours: 8760 },
        { label: '5 Years', hours: 43800 },
    ];

    // Форматирование числа с пробелами
    function formatNumber(num) {
        if (num >= 1_000_000) {
            return (num / 1_000_000).toFixed(2).replace('.', '.') + 'М';
        }

        if (Number.isInteger(num)) {
            return num.toLocaleString('en');
        } else {
            return num.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }

    // Расчёт result для каждого периода
    const calculateReward = (hours) => {
        const balance = props.earned || 0; // Если balance не передаётся, используем 0

        // const usdPrice = props.usdPrice || 1; // Если usd_price не передаётся, используем 1
        const result = balance + userData.user_main_balance * (props.hourlyPercent / 100) * hours;
        return result;
    };

    return (
        <div className='rewardCard'>
            <div className='rewardCard__top'>
                <div className='rewardCard__topInfo'>
                    <div className='rewardCard__currency'>
                        <div className='rewardCard__currencyIcon'>
                            <img src={props.currencyIcon} alt="" />
                        </div>
                        <div className='rewardCard__currencyName appearanceAnimation'>
                            {props.currencyName}
                        </div>
                    </div>
                    <div className='rewardCard__valueWrapper'>
                        <div className='rewardCard__valueIcon'>
                            <img style={{display: 'flex'}} src={resources.icons.bag} />
                        </div>
                        <div className='rewardCard__value appearanceAnimation'>{props.value}</div>
                    </div>
                </div>
                <div className='rewardCard__topBtns'>
                    <div onClick={toggleMenu}>
                        <Button>Calculate reward</Button>
                    </div>
                    <DropdownButton id={props.id} />
                </div>
            </div>
            <ul className={isOpen ? 'rewardCard__bottom active' : 'rewardCard__bottom'}>
                {periods.map((period) => {
                    const result = calculateReward(period.hours);
                    const formattedResult = formatNumber(result);
                    const isLarge = result > 100000 && result < 1000000;
                    // const style = isLarge10 ? { fontSize: '10px' } : isLarge17 ? { fontSize: '8px' } : {};

                    return (
                        <li key={period.label}>
                            <div className='rewardCard__bottomLeft appearanceAnimation'>
                                {period.label}
                            </div>
                            <div
                                className='rewardCard__bottomRight appearanceAnimation'
                                style={isLarge ? { fontSize: '14px' } : {}}
                            >
                                {`${formattedResult} ${props.currencyName}`}
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default RewardCard;